import { RequestSerivceToastGroup } from '@cat-ecom/pcc-components';
import { useTranslations } from 'next-intl';

interface RequestEquipmentServiceToastProps {
  setShowToast: (bool) => void;
}

const RequestEquipmentServiceToast = ({
  setShowToast
}: RequestEquipmentServiceToastProps) => {
  const t = useTranslations();

  return (
    <RequestSerivceToastGroup
      toastGroupProps={{
        verticalPosition: 'top',
        horizontalPosition: 'center'
      }}
      toastProps={{
        onBlToastClose: () => setShowToast(false),
        message: t('RS_DEALER_CHANGE_TOAST'),
        variant: 'success'
      }}
    />
  );
};
export default RequestEquipmentServiceToast;
